import { Suspense, Fragment, lazy, useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ForcePasswordChangeModal from "app/components/ForcePasswordChangeModal";

// import Customizer from "./shared/Customizer";

const layouts = {
  layout1: lazy(() => import("./layout-1/Layout1")),
  layout2: lazy(() => import("./layout-2/Layout2"))
};

export default function GullLayout({ children }) {
  const { settings } = useSelector((state) => state.layout);
  const { user } = useSelector((state) => state.auth);
  const mustChange = useMemo(() => Boolean(user?.mustChangePassword), [user]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (mustChange) setShow(true);
  }, [mustChange]);

  // SELECTED LAYOUT BASED ON ACTIVE SETTING
  const Layout = layouts[settings.activeLayout];

  return (
    <Suspense>
      <Fragment>
        <Layout>{children}</Layout>
        <ForcePasswordChangeModal show={show} onClose={() => setShow(false)} />
        {/* {settings.customizer.show ? <Customizer /> : null} */}
      </Fragment>
    </Suspense>
  );
}
